var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5C6.48 3.5 2 7.98 2 13.5C2 19.02 6.48 23.5 12 23.5C17.52 23.5 22 19.02 22 13.5C22 7.98 17.52 3.5 12 3.5ZM8.53 14.97C8.82 15.26 8.82 15.74 8.53 16.03C8.38 16.18 8.19 16.25 8 16.25C7.81 16.25 7.62 16.18 7.47 16.03L5.47 14.03C5.18 13.74 5.18 13.26 5.47 12.97L7.47 10.97C7.76 10.68 8.24 10.68 8.53 10.97C8.82 11.26 8.82 11.74 8.53 12.03L7.06 13.5L8.53 14.97ZM13.69 11.46L11.69 16.13C11.57 16.41 11.29 16.58 11 16.58C10.9 16.58 10.8 16.56 10.71 16.52C10.33 16.36 10.15 15.92 10.32 15.53L12.32 10.86C12.48 10.48 12.92 10.3 13.3 10.47C13.68 10.64 13.85 11.08 13.69 11.46ZM18.53 14.03L16.53 16.03C16.38 16.18 16.19 16.25 16 16.25C15.81 16.25 15.62 16.18 15.47 16.03C15.18 15.74 15.18 15.26 15.47 14.97L16.94 13.5L15.47 12.03C15.18 11.74 15.18 11.26 15.47 10.97C15.76 10.68 16.24 10.68 16.53 10.97L18.53 12.97C18.82 13.26 18.82 13.74 18.53 14.03Z",
    fill: "#008AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.a80bf53d3f1bbdd3ef34f9c3bae86617.svg";
export { ForwardRef as ReactComponent };